<template>
  <section v-if="data" :class="$style.root">
    <div :class="$style.content">
      <pagesExhibitionsSlugDocumentationComponent :data="data" />
    </div>

    <LayoutPrevNextPageComponent :class="$style.prevNext" :prev="getAttributes(prev)" :next="getAttributes(next)" />
  </section>
  <SharedErrorComponent v-else-if="error" :error="error" />
</template>

<script lang="ts" setup>
const route = useRoute()

const getAttributes = baseStrapiGetAttributes

// 1
useHead({
  htmlAttrs: { 'data-page-type': 'exhibitions' }
})

// 2
const { data, error } = await useAsyncData(`exhibitions-slug-documentation-${route.params.slug}`, () =>
  fetchQueryPath( queryExhibitionEntryDocumentationBySlug(baseStrapiGetSlugQueryObjectFromRoute()) )
)

const attributes = baseStrapiGetAttributes(data?.value)
const defaultOgImageUrl = attributes?.coverImage?.data?.attributes?.url ? baseStrapiGetAbsoluteFileUrl(attributes?.coverImage?.data?.attributes?.url, attributes?.coverImage?.data?.provider) : null
basePageSetHead(data, defaultOgImageUrl)

// 3
const prevQueryOptions = baseStrapiGetPrevNextQueryObject(getAttributes(data)?.dateStart, '$lt', 'desc')
const { data: prev } = await useAsyncData(`exhibitions-slug-documentation-prev-${route.params.slug}`, () =>
  fetchQueryPath( queryExhibitionEntryPrevNextBySlug(prevQueryOptions) )
)

const nextQueryOptions = baseStrapiGetPrevNextQueryObject(getAttributes(data)?.dateStart, '$gt', 'asc')
const { data: next } = await useAsyncData(`exhibitions-slug-documentation-next-${route.params.slug}`, () =>
  fetchQueryPath( queryExhibitionEntryPrevNextBySlug(nextQueryOptions) )
)
</script>

<style module>
.root {
  display: flex;
  flex-direction: column;
}

.content {
  flex: 1;
}

.prevNext {
  margin-top: calc(var(--lh, 1em) * 2);
}
</style>
